import { render, staticRenderFns } from "./BasePhotoDetails.vue?vue&type=template&id=eb376de4&"
import script from "./BasePhotoDetails.vue?vue&type=script&lang=js&"
export * from "./BasePhotoDetails.vue?vue&type=script&lang=js&"
import style0 from "./BasePhotoDetails.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports